import React from "react"
import styled from "styled-components"
import { isMobile } from "react-device-detect"

import { PlanSummaryBody, PlanSummaryBodyProps } from "./body"
import { PlanSummaryFooter, PlanSummaryFooterProps } from "./footer"

import { Modal, ModalProps } from "components/modal"
import { Flex } from "components/box"
import { H5 } from "components/text"

const Container = styled(Flex).attrs({
  flexDirection: "column",
  pt: 6,
  px: 6,
  bg: "lightSalmon"
})`
  box-shadow: 0 1px 4px rgba(215, 220, 218, 0.5);
  border-radius: 0.3125rem;
`

const SeparatorDesktop = styled.hr`
  border: 2px solid ${props => props.theme.colors.peach};
  border-width: 0.0625rem;
  width: 100%;
  margin: 0;
`

const SeparatorMobile = styled.hr`
  position: absolute;
  left: 0;
  top: 3.75rem;

  border: 0.375rem solid ${props => props.theme.colors.iceBlue};
  border-width: 0.1875rem;
  width: 100%;
  margin: 0;
`

const PlanSummary: React.FC<PlanSummaryBodyProps & PlanSummaryFooterProps & ModalProps> = ({
  children,
  hasAddedProduct,
  subtotal,
  onContinue,
  isOpen,
  setIsOpen
}) => (
  <>
    {!isMobile && (
      <Container>
        <H5 color="evergreen" mb={4}>
          Plan Summary
        </H5>
        <SeparatorDesktop />
        <PlanSummaryBody hasAddedProduct={hasAddedProduct}>{children}</PlanSummaryBody>
        <PlanSummaryFooter hasAddedProduct={hasAddedProduct} subtotal={subtotal} onContinue={onContinue} />
      </Container>
    )}

    {isMobile && (
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} iconColor="evergreen">
        <Flex flexDirection="column" pb={3} height="100%">
          <Flex pt={5} flexDirection="column" width="100%" position="fixed" bg="white">
            <H5 width="100%" textAlign="center" color="evergreen" mb={4}>
              Plan Summary
            </H5>
            <SeparatorMobile />
          </Flex>
          <PlanSummaryBody hasAddedProduct={true}>{children}</PlanSummaryBody>
          <PlanSummaryFooter hasAddedProduct={true} subtotal={subtotal} onContinue={onContinue} />
        </Flex>
      </Modal>
    )}
  </>
)

export default PlanSummary
